<div class="page-section series-form-page">
    <div class="app-l-page__navigation">
        <div class="app-l-page__previous" [routerLink]="['/admin/organization-listing']">
            <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item">
                    <a [routerLink]="['/admin/organization-listing']">Organizations</a>
                </li>
                <li class="breadcrumbs-list-item app-l-current-page">
                    {{ title }}
                </li>
            </ul>
        </div>
    </div>
    <div class="page-section-content">
        <page-loader *ngIf="!isLoaded"></page-loader>
        <div class="form-wrapper-80" *ngIf="isLoaded && orgAuth">

            <div class="app-c-form-group">
                <label class="app-c-form--label" for="EntityId">IDP Entity ID</label>
                <input
                    class="app-c-form-control"
                    type="text"
                    [(ngModel)]="orgAuth.EntityId"
                    name="EntityId"
                    id="EntityId" />
            </div>

            <div class="fixed-footer">
                <button
                    type="button"
                    class="app-c-btn app-c-btn--primary app-c-btn--curve"
                    (click)="doSave()">Save</button>
            </div>
        </div>
    </div>
</div>
